const e = { amount: 1, efficiency: "", equipmentGroupId: "", equipmentManufacturer: null, equipmentModel: "", equipmentType: null, factoryNumber: "", heatingArea: "", hourlyCost: "", isReserve: false, maintenanceEndDate: "", power: "", serviceOrganizationId: "", gasMeteringNodes: [], equipmentGroup: null };
export {
  e as defaultFormValues
};
//# sourceMappingURL=defaultFormValues.js.map
